import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query';

export interface IRequestHeaders {
  token: string;
  extraHeaders: HeadersInit;
}

export type TCustomBaseQueryType = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, object, FetchBaseQueryMeta>;

export const appendHeaders = (headers: Headers) => {
  headers.set('X-Custom-Header', 'games');
  return headers;
};

const baseQuery = fetchBaseQuery({
  baseUrl: '/',
  prepareHeaders: (headers) => appendHeaders(headers),
});

export const customBaseQuery: TCustomBaseQueryType = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  const { error, meta } = result;
  const location = meta?.response?.url;

  if (error) {
    if ('originalStatus' in error && error?.originalStatus >= 500) {
      console.log('Определиться с адресом страницей тех работ');
    }

    if (location) {
      window.location.href = location;
    }
  }

  return result;
};
